import { render } from "./PeriodArchivePage.vue?vue&type=template&id=1f228974&scoped=true"
import script from "./PeriodArchivePage.vue?vue&type=script&lang=js"
export * from "./PeriodArchivePage.vue?vue&type=script&lang=js"

import "./PeriodArchivePage.vue?vue&type=style&index=0&id=1f228974&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f228974"]])

export default __exports__